// extracted by mini-css-extract-plugin
export default {"container":"styles_container__S97qq","countMessages":"styles_countMessages__smyVn"};